export default {
    selectRoot(resources, response) {
        return resources[response.xhr.url] || null;
    },
};
//# sourceMappingURL=RedirectTargetSelector.js.map